import { fromEnumAsString, toEnumFromString } from '../../../serialization/enum-utils.js';
import { MapUtils } from '../../../utility/map-utils.js';
import { isSameMap, mapToData } from '../../dto/data-model-utils.js';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../../dto/data-model.js';
import { SeatObjectState } from './seat-object-state.js';

export class SeatStateStatistics extends DataModel {
  static readonly TYPE_ID: string = '3f625307b0da4a4ba93200158c164ae2';

  private constructor(
    public readonly seatCount: number,
    public readonly statistics: Map<SeatObjectState, number>,
  ) {
    super();
  }

  get $typeId(): string {
    return SeatStateStatistics.TYPE_ID;
  }

  static empty(): SeatStateStatistics {
    return new SeatStateStatistics(
        0,
        new Map<SeatObjectState, number>(),
    );
  }

  static create(args: {
      seatCount: number,
      statistics: Map<SeatObjectState, number>,
    }): SeatStateStatistics {
    return new SeatStateStatistics(
        args.seatCount,
        args.statistics,
    );
  }

  static fromMap(
      context: SerializationContext,
      map: SerializedData,
  ): SeatStateStatistics {
    return new SeatStateStatistics(
        MapUtils.getInteger(map, 'seatCount'),
        MapUtils.getMap(map, 'statistics', (k, v) => {
          return { key: toEnumFromString(k, SeatObjectState), value: v as number };
        }),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      seatCount: this.seatCount,
      statistics: mapToData(this.statistics, (k, v) => {
        return { key: fromEnumAsString(k), value: v };
      }),
    };
  }

  clone(): this {
    return this.copyWith() as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.seatCount === this.seatCount &&
      isSameMap(other.statistics, this.statistics);
  }

  copyWith({
    seatCount = this.seatCount,
    statistics = this.statistics,
  }: {
      seatCount?: number,
      statistics?: Map<SeatObjectState, number>,
    } = {}): this {
    return new SeatStateStatistics(
        seatCount,
        statistics,
    ) as this;
  }
}

export class SeatStateStatisticsBuilder extends DataModelBuilder<SeatStateStatistics> {
  build(context: SerializationContext, map: SerializedData): SeatStateStatistics {
    return SeatStateStatistics.fromMap(context, map);
  }
}
